import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import * as React from "react";
import { useContext } from "react";
import { css } from "styled-components";

const enum fields {
    orderLabel = "orderLabel",
}

interface Props extends WidgetProps {
    fields: {
        [fields.orderLabel]: string;
    };
}
export interface OrderDetailsTitleStyles {
    titleText: TypographyProps;
    orderTitle: TypographyPresentationProps;
}

export const titleStyles: OrderDetailsTitleStyles = {
    titleText: {
        variant: "h2",
        as: "h1",
    },
    orderTitle: {
        css: css`
            font-size: 32px;
            font-weight: 26;
            margin-bottom: 1rem;
            display: block;
        `,
    },
};

const styles = titleStyles;

const OrderDetailsTitle: React.FC<Props> = props => {
    const { value: order } = useContext(OrderStateContext);
    if (!order) {
        return null;
    }
    const label =
        props.fields.orderLabel && props.fields.orderLabel.length > 0
            ? props.fields.orderLabel
            : order.erpOrderNumber
            ? "Order #"
            : "Web Order #";
    return (
        <Typography as="h1" mergeCss={true} {...styles.orderTitle}>
            {order.erpOrderNumber
                ? `${translate(label)}${order.erpOrderNumber}`
                : `${translate(label)}${order.webOrderNumber}`}
        </Typography>
    );
};

const widgetModule: WidgetModule = {
    component: OrderDetailsTitle,
    definition: {
        allowedContexts: ["OrderDetailsPage", "VmiOrderDetailsPage", "QuoteHistoryDetailsPage"],
        group: "Order Details",
        fieldDefinitions: [
            {
                name: fields.orderLabel,
                displayName: "Order Label",
                editorTemplate: "TextField",
                defaultValue: "Order #",
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
